<template>
  <div :class="componentClassName">
    <span class="a-audio-player-progress-bar__text a-audio-player-progress-bar__text--start">{{ currentTime }}</span>
    <div class="a-audio-player-progress-bar__slider">
      <span class="a-audio-player-progress-bar__slider-percentage" :style="{ width: changeWidth + '%' }" />
      <input v-model="progress" type="range" min="0" max="100" step="1" @input="handleDebounceChangeProgress" />
    </div>
    <span class="a-audio-player-progress-bar__text a-audio-player-progress-bar__text--end">{{ time }}</span>
  </div>
</template>

<script>
import { mapModifiers } from '@/libs/component';
import { debounce } from 'lodash';
import { convertSecondsToElapsedTime, convertElapsedTimeToSeconds } from '@/libs/utils';

export default {
  name: 'a-audio-player-progress-bar',
  props: {
    class: {
      type: String,
      default: '',
    },
    time: {
      type: String,
      default: '0:00',
    },
    start: {
      type: String,
      default: '0:00',
    },
    modelValue: {
      type: String,
      default: null,
    },
  },
  emits: ['progress', 'update:modelValue'],
  data() {
    return {
      progress: '0',
      currentTime: '0:00',
    };
  },
  computed: {
    componentClassName() {
      const baseClassName = mapModifiers('a-audio-player-progress-bar');
      return `${baseClassName} ${this.class}`.trim();
    },
    changeWidth() {
      return this.progress;
    },
  },
  watch: {
    start(val) {
      this.setCurrentValue(val);
    },
    modelValue(val) {
      this.currentTime = val;
    },
  },
  mounted() {
    if (this.start) {
      this.setCurrentValue(this.start);
    }
    if (this.modelValue) {
      this.setCurrentValue(this.modelValue);
    }
  },
  methods: {
    handleDebounceChangeProgress: debounce(function () {
      const seconds = convertElapsedTimeToSeconds(this.time);
      this.currentTime = convertSecondsToElapsedTime((seconds * this.progress) / 100);
      this.$emit('update:modelValue', this.currentTime);
      this.$emit('progress', {
        progress: this.progress,
        current: this.currentTime,
      });
    }, 100),
    setCurrentValue(val) {
      this.currentTime = val;
      // get duration from text
      const seconds = convertElapsedTimeToSeconds(this.currentTime);
      // get total
      const totalSeconds = convertElapsedTimeToSeconds(this.time);
      // calculate progress
      const progress = Number((seconds / totalSeconds) * 100) || 0;
      this.progress = progress;
    },
  },
};
</script>
